#import "../fragments/chatbot-report-db-metrics-fragment.graphql"
#import "../fragments/chatbot-report-ai-metrics-fragment.graphql"

query GetChatbotReport($period: String!, $contactFilter: ContactFilter) {
    chatbotReport(period: $period, contactFilter: $contactFilter) {
        aiMetrics {
            ...ChatbotReportAiMetricsFragment
        }
        dbMetrics {
            ...ChatbotReportDbMetricsFragment
        }
    }
}
